import { render, staticRenderFns } from "./AboutDetails.vue?vue&type=template&id=4a41baeb&scoped=true"
import script from "./AboutDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./AboutDetails.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AboutDetails.vue?vue&type=style&index=0&id=4a41baeb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a41baeb",
  null
  
)

export default component.exports